module.exports = __webpack_public_path__ + "img/poker-s02.8269f36b.svg";